import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router'
import { useLocalizedNavigate } from '@/shared/hooks'
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react'

export function PaymentCancelPage() {
  const { t } = useTranslation()
  const navigate = useLocalizedNavigate()
  const [searchParams] = useSearchParams()

  const projectShortId = searchParams.get('project')

  const handleBack = () => {
    if (projectShortId) {
      navigate(`/p/${projectShortId}`)
    } else {
      navigate('/dashboard')
    }
  }

  const handleRetry = () => {
    // Go back to the project page where they can try again
    if (projectShortId) {
      navigate(`/p/${projectShortId}`)
    } else {
      navigate('/dashboard')
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background-secondary p-4">
      <div className="w-full max-w-md rounded-xl bg-white p-8 shadow-lg">
        <div className="flex flex-col items-center gap-4 text-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-amber-100">
            <XCircle className="h-8 w-8 text-amber-600" />
          </div>
          <h1 className="text-xl font-semibold text-foreground">
            {t('payment.cancelled')}
          </h1>
          <p className="text-sm text-foreground-muted">
            {t('payment.cancelledDescription')}
          </p>
          <div className="mt-4 flex gap-3">
            <button
              onClick={handleBack}
              className="inline-flex items-center gap-2 rounded-lg border border-border px-4 py-2 text-sm font-medium text-foreground transition-colors hover:bg-background-secondary"
            >
              <ArrowLeft className="h-4 w-4" />
              {t('payment.backToProject')}
            </button>
            <button
              onClick={handleRetry}
              className="inline-flex items-center gap-2 rounded-lg bg-accent px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-accent/90"
            >
              <RefreshCw className="h-4 w-4" />
              {t('payment.tryAgain')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
